import { PropsWithChildren } from 'react';

interface DropdownSectionTitleProps {}

const DropdownSectionTitle = ({
  children,
}: PropsWithChildren<DropdownSectionTitleProps>) => {
  // presentation: section titles are visual grouping only — they must not be
  // announced as options inside the listbox
  return (
    <li role="presentation" className="sup-dropdown-section-title">
      {children}
    </li>
  );
};

export default DropdownSectionTitle;
